import React from "react";
import * as echarts from "echarts";
import axios from "axios";

class SparkleCard extends React.Component {
  state = {
    updateData: [], // Data for the sparkline chart
    money: "Loading...", // Placeholder until data is fetched
  };

  componentDidMount() {
    this.timeoutID = undefined;
    this.fetchData();
    this.chartPlace();
  }

  fetchData = async () => {
    const { apiUrl, heading } = this.props; // Get apiUrl and heading from props
    try {
      const response = await axios.get(apiUrl);
      console.log(`API Response for ${heading}:`, response?.data);
  
      let count = 0;
  
      if (heading === "Total Users") {
        // Count users based on the "users" array in the response
        count = response.data.users ? response.data.users.length : 0;
      } else if (heading === "Total Stores") {
        // Count stores based on the "brands" array in the response
        count = response.data.brands ? response.data.brands.length : 0;
      } 
      else if (heading === "Total Brands") {
        console.log('Response:', response); // Debugging step to check the response structure
    
        // Ensure the "total" field exists and is a valid number
        count = response.data.total && typeof response.data.total === 'number' ? response.data.total : 0;
    }
    
    else if (heading === "Total Product Category") {
      // Initialize count to 0
      count = 0;
  
      // Check if categories exist and is an array
      if (Array.isArray(response.data.categories)) {
          // Set count to the length of the categories array
          count = response.data.categories.length;
      } else {
          console.error('Categories data is not an array or is undefined.');
      }
  }
  
  
      else if (heading === "Active Deals") {
        // Filter deals to get only the active ones
        const activeDeals = response.data.deals.filter(deal => deal.status === "active");
        
        // Count the active deals
        count = activeDeals.length;
    
        // Now, you can render or work with the `activeDeals` array, which contains only deals with an active status.
    }else if (heading === "Active Packages") {
        // Count the total number of brands in the "data" array
        const activePackages = response.data.filter(deal => deal.status === "active");
        
        // Count the active deals
        count = activePackages.length;
      }else {
        console.error("Unexpected API response format:", response?.data);
        this.setState({ money: "Error loading data" });
        return;
      }
  
      // Generate random data for the chart
      const sparklineData = Array.from({ length: 6 }, () => Math.random() * 10);
  
      this.setState(
        {
          money: `${count} Items`, // Display the count of items
          updateData: sparklineData,
        },
        () => {
          this.ploatData(this.state.updateData); // Call ploatData with the updated sparkline data
        }
      );
  
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ money: "Error loading data" });
    }
  };
  


  
  ploatData = (data) => {
    const reData = data.map(() => Math.floor(Math.random() * 10) + 1);

    this.timeoutID = setTimeout(() => {
      this.ploatData(this.state.updateData);
      this.chartPlace();
    }, 5000);

    this.setState({ updateData: reData });
  };

  chartPlace = () => {
    const { sparklineData } = this.props; // Get sparklineData from props
    const { updateData } = this.state;

    const chartDom = document.getElementById("main" + this.props.index);
    const myChart = echarts.init(chartDom);

    const option = {
      tooltip: {
        trigger: "axis",
        formatter: function (value) {
          return value[0].data;
        },
      },
      grid: {
        left: 0,
        bottom: 0,
        top: 5,
        right: 0,
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          axisLine: { show: false },
          data: [0, 1, 2, 3, 4, 5],
        },
      ],
      yAxis: [
        {
          type: "value",
          splitLine: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
        },
      ],
      series: [
        {
          type: sparklineData.type, // Use type from sparklineData
          data: updateData,
          areaStyle: {
            color: sparklineData.areaStyle.color, // Use color from sparklineData
          },
          itemStyle: {
            color: sparklineData.areaStyle.color, // Use color from sparklineData
          },
          symbolSize: 1,
        },
      ],
    };

    myChart.setOption(option);
  };

  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }

  render() {
    const { heading } = this.props; // Get heading from props
    const { money } = this.state;

    return (
      <div className="card overflowhidden number-chart">
        <div className="body">
          <div className="number">
            <h6>{heading}</h6>
            <span>{money}</span>
          </div>
        </div>
        <div
          id={"main" + this.props.index}
          className="sparkline"
          style={{ width: "100%", height: 55 }}
        ></div>
      </div>
    );
  }
}

export default SparkleCard;

